import { ValidationError, RequestError, SearchError } from '@/services/errorHandler.service'
import BackendApi from '@/services/backend.service'
import CustomException from '@/services/customException'

const state = {
  isLoadingNotifications: false,
  notifications: []
}

const getters = {
  visibleNotification: (state) => {
    return state.notifications.filter((notification) => Number(notification.status) === 1) || null
  }
}

const mutations = {
  SET_IS_LOADING_NOTIFICATIONS(state, payload) {
    state.isLoadingNotifications = payload
  },
  SET_NOTIFICATIONS(state, payload) {
    state.notifications = payload
  },
  ADD_NOTIFICATION(state, payload) {
    state.notifications.unshift(payload)
  },
  REMOVE_NOTIFICATION(state, payload) {
    const notificationId = payload.notification_id ?? payload.id
    const userNotificationId = payload.user_notification_id

    state.notifications = state.notifications.filter((notification) => {
      if (userNotificationId != null && notification.user_notification_id === userNotificationId) {
        return false
      }
      if (notificationId != null && notification.notification_id === notificationId) {
        return false
      }
      return true
    })
  },
  SET_STATUS_NOTIFICATION(state, payload) {
    const { notification } = payload
    const targetNotification = state.notifications.find((n) =>
      (notification.notification_id != null && n.notification_id === notification.notification_id) ||
      (notification.user_notification_id != null && n.user_notification_id === notification.user_notification_id) ||
      (notification.id != null && n.notification_id === notification.id)
    )

    if (targetNotification) {
      targetNotification.status = 0
      targetNotification.is_read = 1
    }
  }
}

const actions = {
  async getNotifications({ commit }, vueContext) {
    commit('SET_IS_LOADING_NOTIFICATIONS', true)

    try {
      const response = await BackendApi.get('/userNotifications', {
        limit: 15,
        page: 1
      })

      if (!response?.data?.success || !response?.data?.data) {
        throw new RequestError(response)
      }

      commit('SET_NOTIFICATIONS', response.data.data)
      commit('SET_IS_LOADING_NOTIFICATIONS', false)
    } catch (error) {
      commit('SET_IS_LOADING_NOTIFICATIONS', false)
      CustomException.handleError({ error }, vueContext)
    }
  },
  async handleNewNotification({ commit, state }, data) {
    if (parseInt(data.user_id) === parseInt($cookies.get('user').id)) {
      const notification = data.notification

      if (notification.action === 'update_status' || Number(notification.status) === 0) {
        const countBefore = state.notifications.length
        commit('REMOVE_NOTIFICATION', notification)
        if (state.notifications.length === countBefore) {
          commit('SET_STATUS_NOTIFICATION', { notification })
        }
        return
      }

      new Audio(require('@/assets/sound/notification-2.mp3')).play()

      notification.status = 1
      notification.is_read = 0
      commit('ADD_NOTIFICATION', notification)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
